import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-new-claim-exit-dialog',
  templateUrl: './new-claim-exit-dialog.component.html',
  styleUrls: ['./new-claim-exit-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule, 
    MatButtonModule, 
    MatDialogModule
  ]
})
export class NewClaimExitDialogComponent {

  constructor(public dialogRef: MatDialogRef<NewClaimExitDialogComponent>) { }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}